import { Helmet } from "react-helmet";
import {
    Box,
    ClickAwayListener,
    Stack,
    MenuItem,
    MenuList,
    Divider,
    InputAdornment,
    TextField,
    Tab,
    Tabs,
    Select,
    Container,
    Grid,
    Typography,
    Button,
    usePagination,
    Grow,
    Popper,
    FormGroup,
    FormControlLabel,
    Checkbox,
    Paper
} from "@mui/material";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers'
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import AccessibleIcon from "@mui/icons-material/Accessible";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import Search from "@mui/icons-material/Search";
import React, { useEffect, useMemo } from "react";
import cssVariables from "../../../../theme/cssVariables";
import { ReactComponent as PlusIcon } from "../../../../icons/plus.svg";
import { ReactComponent as ChevronExpandDown } from "../../../../assets/icons/chevron-expand-down.svg";
import { ReactComponent as ChevronExpandUp } from "../../../../assets/icons/chevron-expand-up.svg";
import { ReactComponent as EditIcon } from "../../../../assets/icons/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/icons/delete.svg";
import { ReactComponent as Calendar } from "../../../../assets/icons/calendar.svg";
import { ReactComponent as FilterStatus } from "../../../../assets/icons/filter-status.svg";
import { ReactComponent as IconImport } from "../../../../assets/icons/import.svg";
import { ReactComponent as Doner } from "../../../../assets/icons/doner.svg";
import { ReactComponent as XIcon } from "../../../../assets/icons/xIcon.svg";
import exports from "../../../../assets/images/export.png";
import { ReactComponent as Nodata } from "../../../../assets/icons/nodata.svg";

import SimpleDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import CustomPagination from "../../../../components/CustomPagination";
import * as Util from "../../../../services/global.service";
import { useSelector, useDispatch } from "react-redux";
import MessageDialog from "../../../../components/inbox/MessageDialog";

const useStyles = makeStyles({
    dateTimePicker: {
        display: "flex !important",
        flexDirection: "column !important",
        justifyContent: "space-between !important",
        position: "relative",
        marginBottom: "14px !important",

    },
    plusSvg: {
        "& > path": {
            fill: "#fff",
            stroke: "#fff",
        },
    },
    input: {
        '& div > input': {
            height: '7px',
            position: "relative"
        }
    },
    draggingListItem: {
        background: 'rgb(235,235,235)'
    },
    toggleBtnRoot: {
        background: `transparent !important`,
        color: "#6B6B6B !important",
        width: "320px",
        border: "none !important",
    },
    toggleBtnSelected: {
        background: `${cssVariables.color.primary}!important`,
        color: "#fff!important",
    },
    flexPaper: {
        flex: 1,
        minWidth: 350,
        "box-shadow": "0px 2px 10px rgba(0, 0, 0, 0.1) !important",
        "border-radius": "10px !important        "
    },
    tab: {
        fontSize: "16px !important",
        fontWeight: "300 !important",
        // color: "#A3A3A3 !important",
        '&.Mui-selected': {
            color: cssVariables.color.primary + " !important"
        }
    },
    root: {
        display: 'flex',
        width: "100%",
        flexWrap: 'wrap'
    }
});

const styles = {
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
};

const ByEmployeeGroup = (props) => {
    const { data, cycle, type, changeCycle, cycleOld, open, setOpen } = props;
    const [items, setItems] = React.useState([]);
    const [mainItems, setMainItems] = React.useState([]);
    let { serial } = useParams()
    const classes = useStyles();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [competencyFormSelect, setCompetencyForm] = React.useState([]);
    const [competencyFormSelectValue, setCompetencyFormValue] = React.useState("");
    const [search, setSearchValue] = React.useState("");
    const [code, setCode] = React.useState("");
    const [name, setName] = React.useState("");
    const [startDate, setStartDate] = React.useState(null);
    const [endDate, setEndDate] = React.useState(null);
    const [updatedBy, setUpdatedBy] = React.useState("");
    const [perPage, setPerPage] = React.useState(10);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [totalPage, setTotalPage] = React.useState(1);
    const [checkResired, setCheckRsquired] = React.useState({});
    const [reSet, setreSet] = React.useState(false);
    const [openAdvanceFilters, setOpenAdvanceFilters] = React.useState(false);
    const anchorRef = React.useRef(null);
    const [active, setActive] = React.useState(true);
    const [notActive, setNotActive] = React.useState(false);
    const [submit, setSunmit] = React.useState(false);
    const [isSuccessDeleteDialogOpen, openSuccessDeleteDialog] = React.useState(false);
    const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
    const checkFilterData = () => {
        let total = 0
        if (formatData(code, false) !== false) {
            total += 1
        }
        if (formatData(name, false) !== false) {
            total += 1
        }
        if (formatData(startDate, false) !== false) {
            total += 1
        }
        if (formatData(endDate, false) !== false) {
            total += 1
        }
        if (formatData(updatedBy, false) !== false) {
            total += 1
        }
        return total;
    }

    const handleSubmit = async () => {
        if (search !== "") {
            setSearchValue("")
        }
        let result = []
        let dataSerach = mainItems
        if (dataSerach !== undefined && dataSerach.length > 0) {
            let resultData = dataSerach.filter(rs => {
                let check = true
                if (formatData(startDate, false) !== false || formatData(endDate, false) !== false) {
                    if (formatData(startDate, false) !== false && formatData(endDate, false) !== false) {
                        if (formatData(rs.updated_at, false) !== false) {
                            if (toTimestamp(rs.updated_at) >= toTimestamp(startDate) && toTimestamp(rs.updated_at) <= toTimestamp(endDate) + 86399.9) {

                            } else {
                                return false;
                            }
                        } else {
                            if (toTimestamp(rs.created_at) >= toTimestamp(startDate) && toTimestamp(rs.created_at) <= toTimestamp(endDate) + 86399.9) {

                            } else {
                                return false;
                            }
                        }
                    } else {
                        if (formatData(startDate, false) !== false) {
                            if (formatData(rs.updated_at, false) !== false) {
                                if (toTimestamp(rs.updated_at) >= toTimestamp(startDate)) {

                                } else {
                                    return false;
                                }
                            } else {
                                if (toTimestamp(rs.created_at) >= toTimestamp(startDate)) {

                                } else {
                                    return false;
                                }
                            }
                        }
                        if (formatData(endDate, false) !== false) {
                            if (formatData(rs.updated_at, false) !== false) {
                                if (toTimestamp(rs.updated_at) <= toTimestamp(endDate) + 86399.9) {

                                } else {
                                    return false;
                                }
                            } else {
                                if (toTimestamp(rs.created_at) <= toTimestamp(endDate) + 86399.9) {

                                } else {
                                    return false;
                                }
                            }
                        }
                    }
                }
                if (formatData(updatedBy, false) !== false) {
                    if (formatData(rs.updated_at, false) !== false) {
                        let checkData = rs.updated_by.fullname.toString().toLowerCase().indexOf(updatedBy.toString().toLowerCase()) !== -1;
                        if (checkData === false) {
                            check = false;
                        }
                    } else {
                        let checkData = rs.created_by.fullname.toString().toLowerCase().indexOf(updatedBy.toString().toLowerCase()) !== -1;
                        if (checkData === false) {
                            check = false;
                        }
                    }
                }
                if (formatData(code, false) !== false) {
                    let checkData = rs.code.toString().toLowerCase().indexOf(code.toString().toLowerCase()) !== -1;
                    if (checkData === false) {
                        check = false;
                    }
                }

                if (formatData(name, false) !== false) {
                    let checkName = rs.name.toString().toLowerCase().indexOf(name.toString().toLowerCase()) !== -1;
                    let checkNameEN = rs?.options.name_en !== undefined ? rs?.options.name_en.toString().toLowerCase().indexOf(name.toString().toLowerCase()) !== -1 : false
                    let checkNameTH = rs?.options.name_en !== undefined ? rs?.options.name_th.toString().toLowerCase().indexOf(name.toString().toLowerCase()) !== -1 : false
                    if (checkNameEN === true || checkNameTH === true || checkName === true) {

                    } else {
                        check = false;
                    }
                }
                return check;
            });
            result = resultData
        } else {
            result = dataSerach;
        }
        if (submit === false) {
            setSunmit(true)
        }
        setOpenAdvanceFilters(false)
        await filterActiveSerach(result);
    }
    const handleCancel = () => {
        setCode("")
        setName("")
        setStartDate(null)
        setEndDate(null)
        setUpdatedBy("")
        setOpenAdvanceFilters(false)
        dataSerachs(mainItems)
    }

    const formatData = (data, defaults) => {
        if (data !== null && data !== undefined && data !== "") {
            return data;
        }
        return defaults;
    }
    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        } else if (event.key === 'Escape') {
            setOpen(false);
        }
    }
    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };
    const filterActiveSerach = (data) => {
        let result = []
        let dataFilter = JSON.parse(JSON.stringify(data))
        if (notActive === false && active === false) {
            sortDataSerachs(result)
        } else if (notActive === true && active === true) {
            sortDataSerachs(data)
        } else {
            if (notActive === true) {
                let resultData = dataFilter.filter(rs => rs?.status === "inactive");
                result = resultData
                sortDataSerachs(result)
            } else if (active === true) {
                let resultData = dataFilter.filter(rs => rs?.status === "active");
                result = resultData
                sortDataSerachs(result)
            }
        }
    };

    const EditNotActive = (data) => {
        if (data === "notActive") {
            setNotActive(!notActive)
        } else if (data === "active") {
            setActive(!active)
        } else if (data === "selectAll") {
            if (notActive === true && active === true) {
                setNotActive(false)
                setActive(false)
            } else if (notActive === false && active === false) {
                setNotActive(true)
                setActive(true)
            } else if (notActive === true || active === true) {
                setNotActive(true)
                setActive(true)
            }
        }
    };
    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };
    const handleSearch = (event) => {
        setSearchValue(event.target.value);
    };
    const handleOpenFailedMessageDialog = (value) => {
        setFailedMessageDialog(true);
    };
    const handleCloseFailedMessageDialog = (value) => {
        setFailedMessageDialog(false);
    };
    const currentData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * perPage;
        const lastPageIndex = firstPageIndex + perPage;
        return items
            .slice(firstPageIndex, lastPageIndex);
    }, [items, currentPage, perPage]);
    const handleTotalPage = () => {
        const List = items
        const totalPage =
            Math.ceil(List.length / perPage) === 0
                ? 1
                : Math.ceil(List.length / perPage);
        setTotalPage(totalPage);
    };
    useEffect(() => {
        handleTotalPage();
    }, [items, perPage]);
    useEffect(() => {
        dataSerachs(mainItems)
    }, [search]);
    useEffect(() => {
        setCompetencyForm(cycle)
        if (Util.formatData(cycle, false) !== false && cycle.length > 0) {
            let cycleNow = cycle.filter((rs) => rs?.is_current === true)
            if (Util.formatData(cycleOld, false) !== false) {
                setCompetencyFormValue(cycleOld)
            } else if (cycleNow.length > 0) {
                setCompetencyFormValue(cycleNow[0]?.serial)
            } else {
                setCompetencyFormValue(cycle[0]?.serial)
            }
        }
    }, [cycle]);

    useEffect(() => {
        if (Util.formatData(competencyFormSelectValue, false) !== false) {
            changeCycle(competencyFormSelectValue)
        }
    }, [competencyFormSelectValue]);

    useEffect(() => {
        dataSerachs(mainItems, "status")
    }, [notActive, active]);

    useEffect(() => {
        setMainItems(data)
        if (submit === false) {
            dataSerachs(data)
        } else {
            handleSubmit()
        }
    }, [data]);

    useEffect(() => {
    }, []);

    const dataSerachs = async (data, type) => {
        let result = []
        let dataSerach = JSON.parse(JSON.stringify(data))
        if (search !== "" && dataSerach !== undefined && dataSerach.length > 0) {
            if (checkFilterData() > 0) {
                handleCancel()
            }
            let resultData = dataSerach.filter(rs => {
                return Object.keys(rs).some(key => {
                    if (key === 'code' || key === 'name' || key === 'organization' || key === 'total') {
                        return rs[key].toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1;
                    }
                    // if (key === 'options') {
                    //     let checkName = false;
                    //     if (rs[key].name_en !== undefined && rs[key].name_en.toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1) {
                    //         checkName = true;
                    //     }
                    //     if (rs[key].name_th !== undefined && rs[key].name_th.toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1) {
                    //         checkName = true;
                    //     }
                    //     return checkName;
                    // }
                });
            });
            result = resultData
        } else {
            result = dataSerach;
        }
        if (type === "status") {
            if (submit === true) {
                handleSubmit()
            } else {
                setSunmit(false)
                await filterActiveSerach(result);
            }
        } else {
            setSunmit(false)
            await filterActiveSerach(result);
        }
    };

    const clickLink = (data) => {
        navigate(data, { replace: false });
    }
    const handleChangeWorkloadForm = (event) => {
        setCompetencyFormValue(event.target.value);
    };
    const handlePerPageChange = (event) => {
        setPerPage(event.target.value);
    };
    const handleSetCurrentPage = (value) => {
        const getSelectedPage = value.filter(item => item.type === "page" && item.selected)
        setCurrentPage(getSelectedPage.length > 0 ? getSelectedPage[0].page : 1)
    };
    const toTimestamp = (strDate) => {
        if (strDate !== "" && strDate !== null && strDate !== undefined) {
            const dt = Date.parse(strDate);
            return dt / 1000;
        } else {
            return 0;
        }
    }

    let sortDataSerachs = (data) => {
        let update = checkResired
        let dataSort = JSON.parse(JSON.stringify(Util.formatData(data)))
        if (Object.keys(checkResired)[0] !== undefined) {
            if (update[Object.keys(checkResired)[0]] === false) {
                dataSort.sort(function (b, a) {
                    if (a[Object.keys(checkResired)[0]] > b[Object.keys(checkResired)[0]]) {
                        return -1;
                    }
                    if (b[Object.keys(checkResired)[0]] > a[Object.keys(checkResired)[0]]) {
                        return 1;
                    }
                    return 0;
                });
                setItems(dataSort)
                setreSet(!reSet)
            } else if (update[Object.keys(checkResired)[0]] === true) {
                dataSort.sort(function (a, b) {
                    if (a[Object.keys(checkResired)[0]] > b[Object.keys(checkResired)[0]]) {
                        return -1;
                    }
                    if (b[Object.keys(checkResired)[0]] > a[Object.keys(checkResired)[0]]) {
                        return 1;
                    }
                    return 0;
                });
                setItems(dataSort)
                setreSet(!reSet)
            }
        } else {
            setItems(dataSort)
        }
    }

    let sortData = (key, check1) => {
        let update = checkResired
        let dataSort = JSON.parse(JSON.stringify(items))
        if (check1 === false && update[key] !== check1) {
            if (key === "created_by" || key === "updated_by") {
                dataSort.sort(function (b, a) {
                    if (Util.formatData(a[key]?.fullname, "") > Util.formatData(b[key]?.fullname, "")) {
                        return -1;
                    }
                    if (Util.formatData(b[key]?.fullname, "") > Util.formatData(a[key]?.fullname, "")) {
                        return 1;
                    }
                    return 0;
                });
            } else {
                dataSort.sort(function (b, a) {
                    if (a[key] > b[key]) {
                        return -1;
                    }
                    if (b[key] > a[key]) {
                        return 1;
                    }
                    return 0;
                });
            }
            update = { [key]: false }
            setItems(dataSort)
            setCheckRsquired(update)
            setreSet(!reSet)
        } else if (check1 === true && update[key] !== check1) {
            if (key === "created_by" || key === "updated_by") {
                dataSort.sort(function (a, b) {
                    if (Util.formatData(a[key]?.fullname, "") > Util.formatData(b[key]?.fullname, "")) {
                        return -1;
                    }
                    if (Util.formatData(b[key]?.fullname, "") > Util.formatData(a[key]?.fullname, "")) {
                        return 1;
                    }
                    return 0;
                });
            } else {
                dataSort.sort(function (a, b) {
                    if (a[key] > b[key]) {
                        return -1;
                    }
                    if (b[key] > a[key]) {
                        return 1;
                    }
                    return 0;
                });
            }
            update = { [key]: true }
            setItems(dataSort)
            setCheckRsquired(update)
            setreSet(!reSet)
        }
    }
    const onOpenAdvanceFilters = () => {
        setOpenAdvanceFilters(!openAdvanceFilters)
    }
    const onCheckCode = (val) => {
        setCode(val)
    }
    const onCheckName = (val) => {
        setName(val)
    }
    const onCheckStartDate = (val) => {
        setStartDate(Util.formatDate(val))
    }
    const onCheckEndDate = (val) => {
        setEndDate(Util.formatDate(val))
    }
    const onCheckUpdatedBy = (val) => {
        setUpdatedBy(val)
    }
    return (
        <Box>
            <Grid container item >
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }} pt="7px">
                    <Typography variant="h2" color="#404349" fontSize={36} lineHeight="40px" >
                        {t('sidebar.label.competencyMapping')} ({t('competencyMapping.byEmployeeSubGroup')})
                    </Typography>
                    {competencyFormSelect.length > 0 ?
                        <Box
                            display="flex"
                            alignItems="flex-start"
                            justifyContent="flex-start"
                            flexDirection="row"
                        >
                            <Select
                                id="workload-select"
                                inputlabelprops={{ shrink: false }}
                                variant="outlined"
                                size="small"
                                sx={{ width: "400px" }}
                                className="white-bg"
                                value={competencyFormSelectValue}
                                onChange={handleChangeWorkloadForm}
                            >
                                {
                                    competencyFormSelect?.length > 0 ?
                                        competencyFormSelect.map(item => {
                                            return (
                                                <MenuItem value={item.serial} key={item.serial}>
                                                    <span style={{ overflow: "hidden", textOverflow: "ellipsis", color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "21px" }}>{item?.name}</span>
                                                </MenuItem>
                                            )
                                        })

                                        : <MenuItem value="">
                                            ---{t('label.notFund')}---
                                        </MenuItem>
                                }
                            </Select>
                        </Box>
                        : null}
                </Box>
            </Grid>
            <Grid container spacing={2}>
                <Grid container item sx={{ height: "100%" }}>
                    <Box sx={{ width: "100%" }}>
                        <Box pt="30px" pb="30px" sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <TextField
                                    id="input-with-icon-textfield"
                                    fullWidth
                                    placeholder={t('competencyMapping.search')}
                                    size="small"
                                    sx={{ background: "#fff", width: "400px", "input": { padding: "11px 14px" }, ".MuiOutlinedInput-root": { color: "#404349", } }}
                                    className="searchTextField-h40"
                                    value={search}
                                    onChange={handleSearch}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Search style={{ color: "#C4C4C4" }} />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <Box onClick={onOpenAdvanceFilters} ml="30px" px="11px" py="8px" sx={{ display: "flex", border: openAdvanceFilters === false ? "1px solid #DADADA" : "1px solid #5DA196", "border-radius": "5px", "align-items": "center", background: openAdvanceFilters === true ? "#E7F1EF" : "", cursor: "pointer", "&:hover": { background: openAdvanceFilters === false ? "#E7F1EF" : "#D8ECE9", border: openAdvanceFilters === false ? "1px solid #5DA196" : "1px solid #5DA196" } }}>
                                    <Doner />
                                    <Typography pl="10px" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.inputForm.advanceFilters')}</Typography>
                                    {checkFilterData() > 0 ?
                                        <Box ml="10px" px="12px" sx={{ background: "#5DA196", "border-radius": "50%", height: "27px", width: "27px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                            <Typography variant="subtitle1" fontWeight="500" color="#FFFFFF" fontSize={16} lineHeight="17.6px" display="flex">{checkFilterData()}</Typography>
                                        </Box>
                                        :
                                        null
                                    }
                                </Box>
                                {checkFilterData() > 0 ?
                                    <Box ml="30px" onClick={handleCancel} sx={{ display: "flex", "align-items": "center", cursor: "pointer" }}>
                                        <XIcon />
                                        <Typography pl="5px" color="#A0A0A0" fontWeight="300" fontSize={16} lineHeight="23.92px" display="flex">{t('admin.inputForm.clearAllFilters')}</Typography>
                                    </Box>
                                    :
                                    null
                                }
                            </Box>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                {/* <Button
                                    size="small"
                                    aria-controls="simple-menu"
                                    aria-haspopup="true"
                                    // onClick={() => clickLink('/admin/goal-group/create/' + serial)}
                                    color="primary"
                                    variant="contained"
                                    sx={{ width: "103px", height: "45px", p: "0", textTransform: "none", "margin-left": "30px" }}
                                // disabled={allow_adjust === true ? false : true}
                                >
                                    <IconImport className={classes.plusSvg} />
                                    <Typography ml={1} fontWeight="500" fontSize={18} lineHeight="26.91px">{t("label.import")}</Typography>
                                </Button> */}
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={{ height: "100%", width: "100%", "max-height": openAdvanceFilters === true ? "390px" : "0px", transition: "all .8s ease-in-out", overflow: "hidden" }} >
                        <Box mb="30px" sx={{ "max-height": "360px", background: "#FFFFFF", "box-shadow": "0px 2px 10px rgba(0, 0, 0, 0.1)", "border-radius": "10px", padding: "26px 40px 40px 37px" }}>
                            <Box pb="3px" sx={{ display: "flex", alignItems: "center" }}>
                                <Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={24} lineHeight="35px" display="flex">{t('admin.inputForm.advanceFilters')}</Typography>
                                {checkFilterData() > 0 ?
                                    <Box ml="20px" px="12px" sx={{ background: "#5DA196", "border-radius": "5px", height: "35px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                        <Typography variant="subtitle1" fontWeight="500" color="#FFFFFF" fontSize={20} lineHeight="22px" display="flex">{checkFilterData()}</Typography>
                                    </Box>
                                    :
                                    null
                                }
                            </Box>
                            <Box pl="3px" sx={{ margin: "0 -12.5px", display: "flex", "flex-flow": "row wrap" }}>
                                <Box pt="12px" sx={{ width: "calc(33.33% - 25px)", ".MuiFormControl-root": { "margin-top": "7px" }, margin: "0 12.5px" }}>
                                    <Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.inputForm.code')}</Typography>
                                    <TextField
                                        fullWidth
                                        margin="normal"
                                        name="description"
                                        onChange={(newValue) => {
                                            onCheckCode(newValue.target.value);
                                        }}
                                        type="text"
                                        value={code}
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                        placeholder={t('admin.inputForm.placeholder.searchCode')}
                                        classes={{ root: classes.input }}
                                    />
                                </Box>
                                <Box pt="12px" sx={{ width: "calc(33.33% - 25px)", ".MuiFormControl-root": { "margin-top": "7px" }, margin: "0 12.5px" }}>
                                    <Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.inputForm.name')}</Typography>
                                    <TextField
                                        fullWidth
                                        margin="normal"
                                        name="description"
                                        onChange={(newValue) => {
                                            onCheckName(newValue.target.value);
                                        }}
                                        type="text"
                                        value={name}
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                        placeholder={t('admin.inputForm.placeholder.searchName')}
                                        classes={{ root: classes.input }}
                                    />
                                </Box>
                                <Box pt="12px" sx={{ width: "calc(33.33% - 25px)", ".MuiFormControl-root": { "margin-top": "7px" }, margin: "0 12.5px" }}>
                                    <Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.label.updatedBy')}</Typography>
                                    <TextField
                                        fullWidth
                                        margin="normal"
                                        name="description"
                                        onChange={(newValue) => {
                                            onCheckUpdatedBy(newValue.target.value);
                                        }}
                                        type="text"
                                        value={updatedBy}
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                        placeholder={t('admin.inputForm.placeholder.searchName')}
                                        classes={{ root: classes.input }}
                                    />
                                </Box>
                                <Box pt="12px" sx={{ width: "calc(33.33% - 25px)", ".MuiButtonBase-root": { "justify-content": "flex-end", position: "absolute", width: "100%", height: "100%", left: "0", "border-radius": "unset" }, ".MuiFormControl-root": { "margin-top": "7px" }, margin: "0 12.5px", '& div > div > input': { height: '7px', }, position: "relative" }} >
                                    <Typography fontSize={16} lineHeight="23.96px" color="#404349" fontWeight="500" sx={{ position: "absolute", bottom: "8px", right: "-16px", }}>
                                        -
                                    </Typography>
                                    <Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.inputForm.updatedDataFrom')}</Typography>
                                    <LocalizationProvider dateAdapter={AdapterDateFns} >
                                        <DatePicker
                                            slots={{
                                                OpenPickerIcon: Calendar
                                            }}
                                            format="dd/MM/yyyy"

                                            value={startDate}
                                            onChange={(newValue) => {
                                                onCheckStartDate(newValue)
                                            }}
                                            // minDate={item.validator.min_date !== undefined && item.validator.min_date !== null && item.validator.min_date !== "" ? formik.values[item.validator.min_date] !== undefined && formik.values[item.validator.min_date] !== null && formik.values[item.validator.min_date] !== "" ? new Date(formik.values[item.validator.min_date]) : null : null}
                                            // maxDate={item.validator.max_date !== undefined && item.validator.max_date !== null && item.validator.max_date !== "" ? formik.values[item.validator.max_date] !== undefined && formik.values[item.validator.max_date] !== null && formik.values[item.validator.max_date] !== "" ? new Date(formik.values[item.validator.max_date]) : null : null}
                                            inputProps={{ placeholder: t('admin.inputForm.placeholder.selectDate'), readOnly: true }}
                                            renderInput={(params) => <TextField {...params}
                                                fullWidth
                                                sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                            />
                                            }
                                        />
                                    </LocalizationProvider>
                                </Box>
                                <Box pt="12px" sx={{ width: "calc(33.33% - 25px)", ".MuiButtonBase-root": { "justify-content": "flex-end", position: "absolute", width: "100%", height: "100%", left: "0", "border-radius": "unset" }, ".MuiFormControl-root": { "margin-top": "7px" }, margin: "0 12.5px", '& div > div > input': { height: '7px', } }}>
                                    <Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.inputForm.updatedDataTo')}</Typography>
                                    <LocalizationProvider dateAdapter={AdapterDateFns} >
                                        <DatePicker
                                            slots={{
                                                OpenPickerIcon: Calendar
                                            }}
                                            format="dd/MM/yyyy"

                                            value={endDate}
                                            onChange={(newValue) => {
                                                onCheckEndDate(newValue)
                                            }}
                                            // minDate={item.validator.min_date !== undefined && item.validator.min_date !== null && item.validator.min_date !== "" ? formik.values[item.validator.min_date] !== undefined && formik.values[item.validator.min_date] !== null && formik.values[item.validator.min_date] !== "" ? new Date(formik.values[item.validator.min_date]) : null : null}
                                            // maxDate={item.validator.max_date !== undefined && item.validator.max_date !== null && item.validator.max_date !== "" ? formik.values[item.validator.max_date] !== undefined && formik.values[item.validator.max_date] !== null && formik.values[item.validator.max_date] !== "" ? new Date(formik.values[item.validator.max_date]) : null : null}
                                            inputProps={{ placeholder: t('admin.inputForm.placeholder.selectDate'), readOnly: true }}
                                            renderInput={(params) => <TextField {...params}
                                                fullWidth
                                                sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                            />
                                            }
                                        />
                                    </LocalizationProvider>
                                </Box>
                            </Box>
                            <Box sx={{ "justify-content": "flex-end", display: "flex", "padding-top": "22px" }}>
                                <Box sx={{ display: "flex", }}>
                                    <Box mr={2} sx={{ width: "100px" }}>
                                        <Button color="black" variant="outlined" fullWidth onClick={handleCancel}>
                                            <Typography sx={{ textTransform: "none" }} fontSize={18} lineHeight="29px" fontWeight="500" color="#6B6B6B">{t('label.cancel')}</Typography>
                                        </Button>
                                    </Box>
                                    <Button onClick={handleSubmit} color="primary" variant="contained" fullWidth>
                                        <Typography sx={{ textTransform: "none" }} fontSize={18} lineHeight="29px" fontWeight="500" color="#FFF">{t('label.applyFilter')}</Typography>
                                    </Button>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                    <div className={classes.root}>
                        <Paper className={classes.flexPaper} >
                            <Box
                                px="40px"
                            >
                                <Box
                                    px="25px"
                                    py="19px"
                                    sx={{ display: "flex", "flex-direction": "row" }}
                                >
                                    {/* 11.442+16.932+11.602+19.002+12.082+14.862+14.072 */}
                                    <Box sx={{ display: "flex", "flex-direction": "row", width: "calc(11.442% - 12.5px)" }} pr="15px">
                                        <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                            {t('admin.inputForm.code')}
                                        </Typography>
                                        <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                            <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("code", true)} />
                                            <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("code", false)} />
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: "flex", "flex-direction": "row", width: "calc(20% - 12.5px)" }} pr="15px">
                                        <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                            {t('admin.label.employeeGroupName')}
                                        </Typography>
                                        <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                            <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("name", true)} />
                                            <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("name", false)} />
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: "flex", "flex-direction": "row", width: "calc(20% - 12.5px)" }} pr="15px">
                                        <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                            {t('competencyMapping.totalCompetency')}
                                        </Typography>
                                        <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                            <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("total", true)} />
                                            <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("total", false)} />
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: "flex", "flex-direction": "row", width: "calc(14.596% - 12.5px)" }} pr="15px">
                                        <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                            {t('competencyMapping.status')}
                                        </Typography>
                                        <Stack direction="row" spacing={2}>
                                            <div>
                                                <FilterStatus
                                                    ref={anchorRef}
                                                    id="composition-button"
                                                    style={{ cursor: "pointer" }}
                                                    onClick={handleToggle}
                                                />
                                                <Popper
                                                    open={open}
                                                    anchorEl={anchorRef.current}
                                                    role={undefined}
                                                    placement="bottom-start"
                                                    transition
                                                    disablePortal
                                                    style={{ "z-index": "1" }}
                                                >
                                                    {({ TransitionProps, placement }) => (
                                                        <Grow
                                                            {...TransitionProps}
                                                            style={{
                                                                transformOrigin:
                                                                    placement === 'bottom-start' ? 'left top' : 'left bottom',
                                                            }}
                                                        >
                                                            <Paper sx={{ "margin-top": "5px !important" }}>
                                                                <ClickAwayListener onClickAway={handleClose}>
                                                                    <MenuList
                                                                        autoFocusItem={open}
                                                                        id="composition-menu"
                                                                        aria-labelledby="composition-button"
                                                                        onKeyDown={handleListKeyDown}
                                                                    >

                                                                        <Box px="16px" py="6px">
                                                                            <FormGroup>
                                                                                <FormControlLabel control={<Checkbox indeterminate={notActive !== active} onChange={e => EditNotActive("selectAll")} checked={notActive === true && active === true ? true : false} />} label={t('competency.selectAll')} />
                                                                                <FormControlLabel control={<Checkbox onChange={e => EditNotActive("notActive")} checked={notActive} />} label={t('admin.label.inactive')} />
                                                                                <FormControlLabel control={<Checkbox onChange={e => EditNotActive("active")} checked={active} />} label={t('admin.label.active')} />
                                                                            </FormGroup>
                                                                        </Box>
                                                                    </MenuList>
                                                                </ClickAwayListener>
                                                            </Paper>
                                                        </Grow>
                                                    )}
                                                </Popper>
                                            </div>
                                        </Stack>
                                    </Box>
                                    <Box sx={{ display: "flex", "flex-direction": "row", width: "calc(17.376% - 12.5px)" }} pr="15px">
                                        <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                            {t('admin.label.createdBy')}
                                        </Typography>
                                        <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                            <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("created_by", true)} />
                                            <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("created_by", false)} />
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: "flex", "flex-direction": "row", width: "calc(16.586% - 12.5px)" }} pr="15px">
                                        <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                            {t('admin.label.updatedBy')}
                                        </Typography>
                                        <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                            <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("updated_by", true)} />
                                            <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("updated_by", false)} />
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: "flex", "flex-direction": "row", width: "75px" }}>
                                        <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ "text-align": "center", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                            {t('admin.label.action')}
                                        </Typography>
                                    </Box>
                                </Box>
                                <Divider width="100%" />
                            </Box>
                            {currentData !== undefined && currentData !== null && currentData.length > 0 ? currentData.map((row, index) => (
                                <Box px="40px">
                                    <Box sx={{ width: "100%", position: "relative", "&:before": { content: '""', position: 'absolute', height: row?.status === "inactive" ? "100%" : "0px", width: row?.status === "inactive" ? "100%" : "0px", top: "0", background: "#FAFAFA", opacity: "0.7" }, }}>
                                        <Box
                                            sx={{ height: "96px", background: "#FFF", width: "100%", display: "flex", "align-items": "center" }}
                                            px="25px"
                                        >
                                            <Box sx={{ width: "calc(11.442% - 12.5px)" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                    {`${row?.code}`}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ width: "calc(20% - 12.5px)" }} pr="15px">
                                                <Typography fontWeight="500" fontSize={16} lineHeight="24px" sx={{ color: "#404349", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                    {row?.name}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ width: "calc(20% - 12.5px)" }} pr="15px">
                                                <Typography fontWeight="400" fontSize={16} lineHeight="24px" sx={{ "text-align": "center", color: "#404349", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                    {row?.total}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ width: "calc(14.596% - 12.5px)" }} pr="15px">
                                                <Typography fontWeight="400" fontSize={16} lineHeight="23.92px" sx={{ color: "#5DA196", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                    {row?.status === "active" ? "ACTIVE" : "INACTIVE"}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", "flex-direction": "column", width: "calc(17.376% - 12.5px)" }} pr="15px">
                                                <Typography fontWeight="400" fontSize={16} lineHeight="24px" sx={{ color: "#404349", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                    {row?.created_by?.fullname !== undefined && row?.created_by?.fullname !== null ? row?.created_by?.fullname : row?.created_at !== undefined && row?.created_at !== null && row?.created_at !== "" ? "Default" : ""}
                                                </Typography>
                                                <Typography fontWeight="400" fontSize={14} lineHeight="21px" sx={{ color: "#A3A3A3", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                    {Util.dateDayTimeFormatAdmin(row?.created_at)}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", "flex-direction": "column", width: "calc(16.586% - 12.5px)" }} pr="15px">
                                                <Typography fontWeight="400" fontSize={16} lineHeight="24px" sx={{ color: "#404349", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                    {row?.updated_by?.fullname !== undefined && row?.updated_by?.fullname !== null ? row?.updated_by?.fullname : row?.updated_at !== undefined && row?.updated_at !== null && row?.updated_at !== "" ? "Default" : ""}
                                                </Typography>
                                                <Typography fontWeight="400" fontSize={14} lineHeight="21px" sx={{ color: "#A3A3A3", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                    {Util.dateDayTimeFormatAdmin(row?.updated_at)}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", "flex-direction": "row", width: "75px", "justify-content": "center" }}>
                                                <Box sx={{ display: "flex", "flex-direction": "row", width: "100px", "z-index": "1", "justify-content": "center" }}>
                                                    <Box >
                                                        <EditIcon style={{ cursor: "pointer" }} onClick={() => { clickLink("/admin/manage-competency-mapping/" + row?.serial + "/" + type + "/" + competencyFormSelectValue) }} />
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Divider width="100%" />
                                </Box>
                            ))
                                :
                                <Box sx={{ "padding-top": "50px", "text-align": "center", "padding-bottom": "500px" }}>
                                    <Nodata />
                                    <Typography color="#A0A0A0" fontWeight="500" fontSize={20} lineHeight="30px" >
                                        {t('label.noDataFilter')}
                                    </Typography>
                                    <Typography color="#A0A0A0" fontWeight="400" fontSize={16} lineHeight="24px" >
                                        {t('label.tryChangingFilter')}
                                    </Typography>
                                </Box>
                            }
                        </Paper>
                    </div>
                </Grid>
            </Grid>
            <Grid container mt={1} spacing={2} >
                <Grid item xs sm md display="flex" alignItems="center">
                    <Box mr={1}>
                        <Typography variant="s14_fw400">{t('label.showMaxItems')}</Typography>
                    </Box>
                    <Select
                        id="pagination"
                        variant="outlined"
                        defaultValue={10}
                        value={perPage}
                        onChange={handlePerPageChange}
                        displayEmpty
                        size="small"
                        className="white-bg"
                    >
                        <MenuItem value={10}>
                            <Typography style={{ fontWeight: "300" }}>10</Typography>
                        </MenuItem>
                        <MenuItem value={20}>
                            <Typography style={{ fontWeight: "300" }}>20</Typography>
                        </MenuItem>
                        <MenuItem value={30}>
                            <Typography style={{ fontWeight: "300" }}>30</Typography>
                        </MenuItem>
                    </Select>
                </Grid>
                <Grid item display="flex" alignItems="center" ml="auto">
                    <Typography variant="s14_fw400">
                        {t('label.page')} {currentPage} {t('label.of')} {totalPage}
                    </Typography>
                </Grid>
                <Grid item ml="auto" display="flex" alignItems="center">
                    <CustomPagination
                        setCurrentPage={handleSetCurrentPage}
                        selected={currentPage}
                        count={totalPage}
                    ></CustomPagination>
                </Grid>
            </Grid>
            <SimpleDialog
                open={isSuccessDeleteDialogOpen}
                setValue={openSuccessDeleteDialog}
                text={t(`admin.label.GoalLibraryGroupDeletedSuccessfully`)}
            />
            <MessageDialog
                open={openFailedMessageDialog}
                setValue={handleCloseFailedMessageDialog}
                type="fail"
                title={t(`dialog.label.fail`)}
                text={t(`admin.label.GoalLibraryGroupDeletedFail`)}
            />
        </Box>
    );
};
export default ByEmployeeGroup;
